import React, { useState } from 'react';
import { Box, Chip, Typography, Alert } from '@mui/material';
import DataTable, { Column } from './DataTable';
interface PendingCancellation {
  id: string;
  transactionId: string;
  mtoName: string;
  payoutType: 'FT' | 'IBFT' | 'OTC';
  amountFCY: string;
  currencyFCY: string;
  currentState: string;
  cancellationReason: string;
  requestedBy: string;
  requestedAt: string;
}

// Mirrors the mock pending-cancellation set shown on the checker side, for a maker-facing status view
const MOCK_PENDING_CANCELLATIONS: PendingCancellation[] = Array(10).fill(null).map((_, index) => ({
  id: `CANC-${40000 + index}`,
  transactionId: `TXN-${30000 + index}`,
  mtoName: ['RIA Money Transfer', 'InstantCash', 'MoneyGram'][index % 3],
  payoutType: ['FT', 'IBFT', 'OTC'][index % 3] as 'FT' | 'IBFT' | 'OTC',
  amountFCY: (1000 + index * 100).toFixed(2),
  currencyFCY: 'USD',
  currentState: ['DOWNLOAD', 'SCREENING', 'TITLE_FETCH'][index % 3],
  cancellationReason: ['Duplicate transaction', 'Customer request', 'Incorrect beneficiary details'][index % 3],
  requestedBy: ['Admin User', 'John Doe', 'Jane Smith'][index % 3],
  requestedAt: new Date(Date.now() - index * 3600000).toISOString()
}));
const MakerCancellationTable: React.FC = () => {
  const [cancellations] = useState<PendingCancellation[]>(MOCK_PENDING_CANCELLATIONS);
  const columns: Column<PendingCancellation>[] = [{
    id: 'id',
    label: 'Request ID',
    renderCell: row => <Typography variant="body2" fontWeight={600} fontFamily="monospace" noWrap data-id="element-1321" data-mp="34hqlxvuwdng9">{row.id}</Typography>
  }, {
    id: 'transactionId',
    label: 'Transaction ID',
    renderCell: row => <Typography variant="body2" fontWeight={600} fontFamily="monospace" noWrap data-id="element-1322" data-mp="2ziw3iv0ue0wo">{row.transactionId}</Typography>
  }, {
    id: 'payoutType',
    label: 'Type',
    renderCell: row => <Chip label={row.payoutType} size="small" sx={{
      backgroundColor: 'rgba(139, 92, 246, 0.1)',
      color: '#8B5CF6',
      fontWeight: 600,
      fontSize: '0.7rem'
    }} data-id="element-1323" data-mp="xq7zijgdj9fu" />
  }, {
    id: 'amountFCY',
    label: 'Amount',
    renderCell: row => <Typography variant="body2" fontWeight={600} noWrap data-id="element-1324" data-mp="2n6tqyicin1xn">{row.currencyFCY} {row.amountFCY}</Typography>
  }, {
    id: 'cancellationReason',
    label: 'Reason',
    renderCell: row => <Typography variant="body2" fontSize="0.8rem" noWrap sx={{
      maxWidth: 200
    }} data-id="element-1325" data-mp="2db05g9gtjy3q">{row.cancellationReason}</Typography>
  }, {
    id: 'status',
    label: 'Status',
    renderCell: () => <Chip label="PENDING" size="small" sx={{
      backgroundColor: 'rgba(245, 158, 11, 0.1)',
      color: '#F59E0B',
      fontWeight: 600,
      fontSize: '0.7rem'
    }} data-id="element-1326" data-mp="35ywac1gjkwbl" />
  }, {
    id: 'requestedAt',
    label: 'Submitted At',
    renderCell: row => <Typography variant="body2" fontSize="0.8rem" noWrap sx={{
      minWidth: 150
    }} data-id="element-1327" data-mp="2wyr2jq7frvww">{new Date(row.requestedAt).toLocaleString()}</Typography>
  }];
  return <Box data-id="element-1328" data-mp="30xzzf3xrw9wo">
      <Alert severity="info" sx={{
      mb: 2,
      borderRadius: 2,
      fontSize: '0.82rem'
    }} data-id="element-1329" data-mp="311nrdynkko9a">
        General cancellation status is read-only here; rejected requests can be re-initiated from the transaction's own Cancel action.
      </Alert>
      <DataTable title="Pending Cancellation Requests" data={cancellations} columns={columns} keyField="id" emptyStateMessage="No pending cancellation requests" initialVisibleColumns={['transactionId', 'payoutType', 'amountFCY', 'cancellationReason', 'status', 'requestedAt']} data-id="element-1330" data-mp="1i0lrix7totjo" />
    </Box>;
};
export default MakerCancellationTable;